/**
 * @module:  页面功能模块
 * @author: Liang Huang
 * @date: 2019-09-23 15:13:28
 */
export default function pageMixin(hybrid) {
  var hybridJs = hybrid;
  var innerUtil = hybridJs.innerUtil;
  hybridJs.extendModule('page', [{
    // 新窗口打开页面
    namespace: 'open',
    os: ['ywk'],
    params: {
      pageUrl: '',
      // 1为无导航栏页面 -1为默认有导航栏页面
      pageStyle: 1,
      // 额外数据,
      data: {}
    },
    runCode: function runCode() {
      var rest = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        rest[_i] = arguments[_i];
      } // 兼容字符串形式


      var args = innerUtil.compatibleStringParamsToObject.call(this, rest, 'pageUrl', 'data');
      var options = args[0]; // 将额外数据拼接到url中

      options.pageUrl = innerUtil.getFullUrlByParams(options.pageUrl, options.data); // 去除无用参数的干扰

      options.data = undefined;

      options.dataFilter = function (res) {
        var newRes = res;

        if (!innerUtil.isObject(newRes.result.resultData)) {
          try {
            newRes.result.resultData = JSON.parse(newRes.result.resultData);
          } catch (e) {}
        }

        return newRes;
      };

      args[0] = options;
      hybridJs.callInner.apply(this, args);
    }
  }, {
    // 打开应用内原生页面
    namespace: 'openLocal',
    os: ['ywk'],
    params: {
      className: '',
      // 为1则是打开已存在的页面，会杀掉所有该页面上的页面
      isOpenExist: 0,
      // 额外数据，注意额外数据只能一层键值对形式，不能再包裹子json
      data: {}
    },
    runCode: function runCode() {
      var rest = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        rest[_i] = arguments[_i];
      }

      var args = rest;
      var options = args[0];

      options.dataFilter = function (res) {
        var newRes = res;

        if (!innerUtil.isObject(newRes.result.resultData)) {
          try {
            newRes.result.resultData = JSON.parse(newRes.result.resultData);
          } catch (e) {}
        }

        return newRes;
      };

      args[0] = options;
      hybridJs.callInner.apply(this, args);
    }
  }, {
    // 关闭页面
    namespace: 'close',
    os: ['ywk'],
    params: {
      // 需要传递的参数，是一个字符串
      resultData: '',
      popPageNumber: 1 // 1 关闭一层 0 关闭所有 支持关闭1层 多层和所有

    },
    runCode: function runCode() {
      var rest = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        rest[_i] = arguments[_i];
      } // 兼容字符串形式


      var args = innerUtil.compatibleStringParamsToObject.call(this, rest, 'resultData');

      if (innerUtil.isObject(args[0].resultData)) {
        args[0].resultData = JSON.stringify(args[0].resultData);
      }

      hybridJs.callInner.apply(this, args);
    }
  }, {
    // 重载页面
    namespace: 'reload',
    os: ['ywk']
  }, {
    // 传个上一个堆栈的页面一个callback用于处理刷新 需要配合registerHandler('page.nextPageClose', callback)使用
    namespace: 'notice',
    os: ['ywk'],
    params: {
      callLastPage: true // 通知上一个页面

    }
  }]);
}